var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnNavi18 = function SvgLightIcnNavi18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.459 1.9a.645.645 0 0 0-.914 0L1.9 8.545a.645.645 0 0 0 0 .914l6.645 6.645a.645.645 0 0 0 .914 0l6.645-6.645.004-.005a.644.644 0 0 0-.003-.908zm-1.621-.708a1.645 1.645 0 0 1 2.328 0l6.648 6.65.005.004c.629.645.64 1.685-.01 2.322l-6.643 6.643a1.645 1.645 0 0 1-2.328 0l-6.646-6.645a1.645 1.645 0 0 1 0-2.328z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.71 6.64 2.361 2.362m0 0-2.36 2.36m2.36-2.36H5.932"
  })));
};
export default SvgLightIcnNavi18;